import Axios from 'axios'

const REPORT_RESOURCE = process.env.VUE_APP_API_ENDPOINT + `/api/print-report`

export default {
  getReportByStore(store) {
    return Axios.get(`${REPORT_RESOURCE}?store=${store}`, {responseType: 'blob'})
  }
};